import * as React from 'react';
import { flow, forEach, map, size, get } from 'lodash';
import { IBrandingState, II18nMessages } from '../../../../services/branding/models';
import { IProduct, ICustomer, IPremium, IQuotes, IChannel } from '../../../../data/api/models';
import { connect } from 'react-redux';
import { Col, Form, Row } from 'react-bootstrap';
import { IStore } from '../../../../redux/IStore';
import { ICompleteData } from '../../../../services/quote/models';
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import FaFileTextO from 'react-icons/fa/file-text-o';
import Loading from '../../../../components/Loading';
import { tagManagerEvent } from '../../../../util/tagManagerEvent';

interface ICompleteProps extends InjectedFormProps {
  i18n: II18nMessages;
  product: IProduct;
  renderDefinition(name: string): any;
  data: ICompleteData;
  customer: ICustomer;
  quote: any;
  quotes: IQuotes;
  branding: IBrandingState;
  premium: IPremium;
  channel: IChannel;
}

class IComplete extends React.Component<ICompleteProps> {
  public state = {
    polling: false,
    pollId: null,
    hasSubmittedGTM: false,
  };

  public componentWillMount() {
    const { data } = this.props;

    if (size(data.documents.documents) > 0) {
      return;
    }

    if (this.state.polling) {
      return;
    }

    this.setState({
      polling: true,
    });

    setTimeout(this.pollDocuments, 2000);
  }

  public componentWillUnmount() {
    this.props.reset();
  }

  public componentDidMount() {
    const { data, channel, quote } = this.props;

    if (!this.state.hasSubmittedGTM) {
      tagManagerEvent({
        event: 'purchase',
        customerName: get(quote, `customer[0].customerName`, ''),
        customerEmail: get(quote, `customer[0].email`, ''),
        policyNumber: data.policy_number,
      }, channel);
      this.setState({
        hasSubmittedGTM: true,
      });
    }
  }

  private renderDocument = (url, name) => {
    return (
      <Col sm={6} key={name}>
        <div className="documents">
          <a href={url} target="_blank">
            <FaFileTextO/>
            <span>
              {name}
            </span>
          </a>
        </div>
      </Col>
    );
  }

  private renderCompleteMessage = () => {
    return (
      <div>
        <div>
          <div className="section-title">
          <p>
            YOU WILL ALSO RECEIVE AN EMAIL SHORTLY WITH DETAILS ON HOW TO
            ACCESS YOUR ACCOUNT AND DOCUMENTS TO DOWNLOAD OR KEEP SAFE.
            Please be aware that this may have gone into your junk or spam folder.
          </p>
          </div>
        </div>
      </div>
    );
  }

  private renderTrackingItems = () => {
    const { branding, premium, data } = this.props;

    const items = [];

    if (branding.aggregatorTracking.type === 'cyti') {
      const params = branding.aggregatorTracking.cyti;
      const cytiUrl = branding.aggregatorTracking.cyti.url + '/track/confirm';

      items.push(
        <img
          key={0}
          // tslint:disable-next-line:max-line-length
          src={`${cytiUrl}?cref=${params.cref}&policyreference=${data.policy_number}&premium=${premium.gross}&t=${params.token}`}
          height="0"
          width="0"
        />,
      );
    }

    if (branding.aggregatorTracking.type === 'idol') {
      const params = branding.aggregatorTracking.idol;
      const url = 'https://www.quote-link.net/travel/salestracking/travelquotes_sale_confirmation.cfm';

      items.push(
        <img
          key={0}
          src={`${url}?ref=${params.reference}&fullprem=${premium.gross}`}
          height="0"
          width="0"
        />,
      );
    }

    return items;
  }

  private pollDocuments = () => {
    const { data, actions } = this.props;

    actions.quote.pollPolicyDocuments(data.documents_poll_token).then(({ documents }) => {
      if (documents.length === 0) {
        this.setState({
          pollId: window.setTimeout(this.pollDocuments, 2000),
        });

        return;
      }

      actions.quote.completeDocuments({ documents });

      this.setState({
        polling: false,
        pollId: null,
      });
    });
  }

  public render() {
    const { data, channel } = this.props;
    let thankYou = 'Thank you for purchasing ' + channel.baseName;
    if (!thankYou.endsWith('Insurance')) {
      thankYou += ' insurance';
    }

    return (
      <Form>
        <div className="steps-container">
          <div className="section-title">
            <h1>You are covered</h1>
          </div>

          <div className="section">
            <Row>
              <h3><strong>{thankYou}</strong></h3>
              <p className="margin-top">
                Your policy number is <span className="policy-number">{data.policy_number}</span>
              </p>

              <p>
                Please find below links to your policy documents.
              </p>

              <div>
                {this.state.polling ? (
                  <div className="policy-documents">
                    <Loading/>
                  </div>
                ) : (
                  <Row className="policy-documents">
                    {map(data.documents, this.renderDocument)}
                  </Row>
                )}
              </div>
              <p>
                We recommend that you read these documents carefully to ensure the details
                are correct and the cover provided meets your needs. Evidence of Cover
                contains the full policy terms, conditions and exclusions of your cover
                as well as details of what to do in the event of a medical emergency.
              </p>
              <div className="clearfix" />
            </Row>
          </div>
          {this.renderCompleteMessage()}
          {this.renderTrackingItems()}
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const { quotes, complete } = state.quote;

      let premium: IPremium = null;

      const values = selector(
        state,
        'tripType',
        'schemeId',
        'quoteReference',
        'steps',
      );

      if (state.quote.quotes) {
        forEach(state.quote.quotes, (tripTypes, level) => {
          forEach(tripTypes, (quotedPremium: IPremium) => {
            if (!quotedPremium) {
              return null;
            }

            if (quotedPremium.scheme.id === values.schemeId) {
              premium = quotedPremium;
            }
          });
        });
      }

      return {
        data: complete,
        quotes,
        branding: state.branding,
        premium,
      };
    },
  ),
])(IComplete);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Complete/index.tsx